import { Button, Checkbox, Grid, Table, TableBody, TableCell, TableRow } from "@mui/material";
import { MinusButton, PlusButton } from "../../../../components/Buttons";
import { supplyCellStyles, tableInRowStyle } from "./supplyTableStyles";
import React, { useCallback } from "react";
import { CustomFormControl, IntegerOrEmptyFormControl } from "../../../../components/FormControl";
import { validateInteger, validateIntegerOrEmpty } from "../../../../utils/validation";
import { inputValueToInt, inputValueToIntOrNull } from "../../../../utils/utils";

const validateUnitQuantity = (unitQuantityValue) => {
  return validateIntegerOrEmpty(unitQuantityValue || "");
}

const validateSupplyQuantity = (supplyQuantityValue) => {
  return validateIntegerOrEmpty(supplyQuantityValue || "");
}

const validateSupplyDetail = (supplyDetail) => {
  return (
    validateUnitQuantity(supplyDetail.supplyUnitQuantity?.toString())
      && validateSupplyQuantity(supplyDetail.supplyQuantity?.toString())
  );
}

export default function SupplyDetailTable({
  supplyQuantityDetails, changeSupplyDetail, addSupplyDetail, deleteSupplyDetail, enabledDisplayRemarks, keyHandler
}) {


  const handleChangeSupplyDetail = useCallback((supplyDetail, fieldName, value) => {

    const newSupplyDetail = {
      ...supplyDetail,
      [fieldName]: value
    };

    changeSupplyDetail(supplyDetail.supplyDetailIndex, {
      ...newSupplyDetail,
      error: !validateSupplyDetail(newSupplyDetail)
    });
  }, [changeSupplyDetail]);

  const handleChangeValidUnitQuantity = (supplyDetail) => (e) => {

    const newSupplyDetail = {
      ...supplyDetail,
      isValidUnitQuantity: e.target.checked,
      supplyUnitQuantity: null
    };

    changeSupplyDetail(supplyDetail.supplyDetailIndex, {
      ...newSupplyDetail,
      error: !validateSupplyDetail(newSupplyDetail)
    })
  }

  const {registerComponent} = keyHandler;

  return (
    <Table>
      <TableBody>
        {
          supplyQuantityDetails.map((supplyDetail, dtlIndex) => (
            <TableRow key={`supplyDetail_${supplyDetail.supplyDetailIndex}`} sx={tableInRowStyle}>
              <TableCell>
                <Grid container spacing={1} alignItems="center">
                  <Grid item sx={{...supplyCellStyles.validUnitQuantityCheck, textAlign: "right"}}>
                    <Checkbox
                      checked={supplyDetail.isValidUnitQuantity}
                      onChange={handleChangeValidUnitQuantity(supplyDetail)}
                      {...registerComponent(dtlIndex, 0)}
                      on
                    />
                  </Grid>
                  <Grid item xs="auto" visibility={supplyDetail.isValidUnitQuantity ? "visible" : "hidden"}>
                    <IntegerOrEmptyFormControl
                      sx={{width: 50, marginRight: 1}}
                      inputProps={{sx:{textAlign: "right"}}}
                      helperTextSx={{width: 50, ml:0, mr: 1}}
                      value={supplyDetail.supplyUnitQuantity != null ? supplyDetail.supplyUnitQuantity.toLocaleString() : ""}
                      onBlurFormat={(v) => validateInteger(v) ? inputValueToInt(v).toLocaleString() : v}
                      setValue={(v) => 
                        handleChangeSupplyDetail(
                          supplyDetail, 
                          "supplyUnitQuantity",
                          validateInteger(v) ? inputValueToInt(v) : v
                        )
                      }                      
                      {...(
                        supplyDetail.isValidUnitQuantity
                          ? registerComponent(dtlIndex, 1)
                          :[]
                      )}
                    />
                  </Grid>
                  <Grid item xs="auto" visibility={supplyDetail.isValidUnitQuantity ? "visible" : "hidden"}>
                    ×
                  </Grid>
                  <Grid item xs="auto">
                    <IntegerOrEmptyFormControl
                      sx={{width: 50, marginLeft: 1}}
                      inputProps={{sx:{textAlign: "right"}}}
                      helperTextSx={{width: 50, ml:1, mr: 0}}
                      value={supplyDetail.supplyQuantity != null ? supplyDetail.supplyQuantity.toLocaleString() : ""}
                      onBlurFormat={(v) => v === "" ? "" : (validateInteger(v) ? inputValueToInt(v).toLocaleString() : v)}
                      setValue={(v) =>
                        handleChangeSupplyDetail(
                          supplyDetail,
                          "supplyQuantity",
                          v === "" ? null : (validateInteger(v) ? inputValueToInt(v) : v)
                        )
                      }
                      {...registerComponent(dtlIndex, 2)}
                    />
                  </Grid>
                  {
                    enabledDisplayRemarks
                      ? (
                        <Grid item xs="auto">
                          <CustomFormControl
                            sx={{width: 100}}                            
                            value={supplyDetail.remarks || ""}
                            setValue={(v) => handleChangeSupplyDetail(supplyDetail, "remarks",v)}
                            {...registerComponent(dtlIndex, 3)}
                          />
                        </Grid>
                      )
                      : null
                  }
                  <Grid item xs="auto">
                    <Button
                      variant="outlined"
                      color="info"
                      onClick={(e)=> addSupplyDetail(supplyDetail.commodityOwnerCd, supplyDetail.remarks)}
                      {...registerComponent(dtlIndex, 4)}
                    >
                      行追加
                    </Button>
                  </Grid>
                  <Grid item xs="auto">
                    <Button
                      variant="outlined"
                      color="error"
                      onClick={(e) => deleteSupplyDetail(supplyDetail.supplyDetailIndex)}
                      disabled={supplyQuantityDetails.length <= 1}
                      {...registerComponent(dtlIndex, 5)}
                    >
                      行削除
                    </Button>
                  </Grid>
                </Grid>
              </TableCell>
            </TableRow>
          ))
        }        
      </TableBody>
    </Table>
  )
};
